// packages/db/src/impl/static/index.ts

export { StaticDataLayerProvider } from './StaticDataLayerProvider';
export { StaticDataUnpacker } from './StaticDataUnpacker';
export { StaticCourseDB } from './courseDB';
export { StaticCoursesDB } from './coursesDB';
export { NoOpSyncStrategy } from './NoOpSyncStrategy';
